<template>
  <v-card class="pa-4" elevation="2">
    <v-stepper v-model="step" flat>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-row>
            <v-col cols="12" md="7">
              <v-card flat>
                <div class="font-weight-bold mb-2" style="font-size: 1.1em;">Informações Pessoais</div>
                <div class="d-flex align-center mb-3">
                  <v-avatar size="64" color="blue lighten-4" class="mr-4">
                    <span class="font-weight-bold" style="font-size: 1.3em; color: #1a237e;">
                      {{ pessoaIniciais }}
                    </span>
                  </v-avatar>
                  <div>
                    <div class="font-weight-bold" style="font-size: 1.3em;">{{ nomeCompleto }}</div>
                    <div v-if="isFisioterapeuta" class="caption">
                      CREFITO: {{ pessoa.fisioterapeuta && pessoa.fisioterapeuta.crefito ? pessoa.fisioterapeuta.crefito : 'Não informado' }}
                    </div>
                    <div class="caption">
                      CPF: {{ pessoa.cpf || 'Não informado' }}
                    </div>
                    <div class="d-flex align-center mt-2">
                      <v-chip :color="statusColor" dark small class="mr-2">{{ statusLabel }}</v-chip>
                      <v-chip v-if="isFisioterapeuta" color="amber lighten-3" small class="mr-1">
                        <v-icon color="amber" small left>mdi-star</v-icon>
                        {{ pessoa.fisioterapeuta && pessoa.fisioterapeuta.nota_fisioterapeuta ? pessoa.fisioterapeuta.nota_fisioterapeuta : '-' }}
                      </v-chip>
                      <v-chip v-if="isPaciente && pessoa.paciente && pessoa.paciente.nota_paciente" color="amber lighten-3" small class="mr-1">
                        <v-icon color="amber" small left>mdi-star</v-icon>
                        {{ pessoa.paciente.nota_paciente }}
                      </v-chip>
                      <span v-if="isFisioterapeuta && pessoa.fisioterapeuta && pessoa.fisioterapeuta.qtd_atendimentos" class="caption">
                        {{ pessoa.fisioterapeuta.qtd_atendimentos }} atendimentos
                      </span>
                      <span v-if="isPaciente && pessoa.qtd_consultas" class="caption">
                        {{ pessoa.qtd_consultas }} consultas realizadas
                      </span>
                    </div>
                  </div>
                </div>
                <div v-if="pessoa && pessoa.tipo_usuario === 2">
                  <div class="mb-2 font-weight-bold">Biografia</div>
                  <div class="mb-4">{{ pessoa && pessoa.descricao ? pessoa.descricao : '' }}</div>
                </div>
                <div v-if="isPaciente" class="mb-2">
                  <div><strong>Uso de remédio contínuo:</strong> {{ pessoa.paciente && pessoa.paciente.uso_remedio_continuo ? pessoa.paciente.uso_remedio_continuo : '-' }}</div>
                  <div><strong>doenças preexistentes:</strong> {{ pessoa.paciente && pessoa.paciente.observacoes_medicas ? pessoa.paciente.observacoes_medicas : '-' }}</div>
                  <div><strong>resumo do seu caso:</strong> {{ pessoa.paciente && pessoa.paciente.resumo_caso ? pessoa.paciente.resumo_caso : '-' }}</div>
                </div>
                <div v-if="isFisioterapeuta" class="mb-2 font-weight-bold">Especialidades</div>
                <div v-if="isFisioterapeuta" class="mb-2">
                  <span v-for="(esp, idx) in especialidades" :key="idx" class="mr-2">
                    <v-chip color="blue lighten-4" small>{{ esp }}</v-chip>
                  </span>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" md="5">
              <v-card flat class="pa-4" style="background: white;">
                <div class="font-weight-bold mb-2" style="font-size: 1.1em;">Contato & Localização</div>
                <div class="mb-2">
                  <v-icon left color="blue">mdi-email</v-icon>
                  <span class="font-weight-bold">Email</span>
                  <div class="caption">{{ pessoa.email || '' }}</div>
                </div>
                <div class="mb-2">
                  <v-icon left color="green">mdi-phone</v-icon>
                  <span class="font-weight-bold">Telefone</span>
                  <div class="caption">{{ pessoa.telefone || '' }}</div>
                </div>
                <div class="mb-2">
                  <v-icon left color="grey">mdi-map-marker</v-icon>
                  <span class="font-weight-bold">Endereço</span>
                  <div class="caption">
                    <span v-if="pessoa.endereco">
                      {{ pessoa.endereco.logradouro }}, {{ pessoa.endereco.numero }}
                      <span v-if="pessoa.endereco.complemento">, {{ pessoa.endereco.complemento }}</span>
                      - {{ pessoa.endereco.bairro }}<br>
                      {{ pessoa.endereco.cidade }} - {{ pessoa.endereco.estado }}<br>
                      {{ pessoa.endereco.pais }}
                    </span>
                  </div>
                </div>
                <div class="mb-2">
                  <v-icon left color="grey">mdi-cake-variant</v-icon>
                  <span class="font-weight-bold">Data de Nascimento</span>
                  <div class="caption">{{ dataNascimentoFormatada }}</div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="mt-4 mb-2" align="center" justify="space-between">
            <div>
              <v-btn color="blue" dark class="mr-4" @click="step = 2">Editar</v-btn>
              <v-btn
                :color="statusBtnInfo.color"
                dark
                @click="mudarStatus()"
              >
                {{ statusBtnInfo.label }}
              </v-btn>
            </div>
            <v-btn color="primary" text @click="$emit('fechar')">Fechar</v-btn>
          </v-row>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-row>
            <v-col cols="12" md="7">
              <v-card flat class="pa-4" style="background: white; border-radius: 16px;">
                <div class="font-weight-bold mb-2" style="font-size: 1.1em;">Editar Dados</div>
                <v-text-field v-model="pessoa.cpf" label="CPF" />
                <v-text-field v-model="pessoa.email" label="Email" />
                <v-text-field v-model="pessoa.telefone" label="Telefone" />
              </v-card>
            </v-col>
          </v-row>
          <v-row class="mt-4 mb-2" align="center" justify="space-between">
            <div>
              <v-btn color="grey" dark class="mr-4" @click="step = 1">Voltar</v-btn>
              <v-btn color="green" dark @click="salvarEdicao">Salvar</v-btn>
            </div>
            <v-btn color="primary" text @click="$emit('fechar')">Fechar</v-btn>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-card>
</template>

<script>
export default {
  props: ['pessoa'],
  data() {
    return {
      step: 1
    }
  },
  computed: {
    pessoaStore() {
      return this.$store.getters.pessoa
    },
    isFisioterapeuta() {
      return this.pessoa && this.pessoa.tipo_usuario === 2
    },
    isPaciente() {
      return this.pessoa && this.pessoa.tipo_usuario === 1
    },
    nomeCompleto() {
      const pessoa = this.pessoa || {}
      return (pessoa.nome || '') + (pessoa.sobrenome ? ' ' + pessoa.sobrenome : '')
    },
    pessoaIniciais() {
      const nome = this.nomeCompleto || ''
      return nome.split(' ').map(n => n[0]).join('').toUpperCase().slice(0,2)
    },
    statusBtnInfo() {
      let ativo = false
      if (this.isFisioterapeuta) {
        ativo = this.pessoa.fisioterapeuta && this.pessoa.fisioterapeuta.ativo
      } else if (this.isPaciente) {
        ativo = this.pessoa.paciente && this.pessoa.paciente.ativo
      }
      return {
        ativo,
        label: ativo ? 'Desativar Conta' : 'Ativar Conta',
        color: ativo ? 'red' : 'green'
      }
    },
    statusLabel() {
      if (this.isFisioterapeuta) {
        return this.pessoa.fisioterapeuta && this.pessoa.fisioterapeuta.ativo ? 'Ativo' : 'Inativo'
      }
      if (this.isPaciente) {
        return this.pessoa.paciente && this.pessoa.paciente.ativo ? 'Ativo' : 'Inativo'
      }
      return '-'
    },
    statusColor() {
      if (this.isFisioterapeuta) {
        return this.pessoa.fisioterapeuta && this.pessoa.fisioterapeuta.ativo ? 'green' : 'red darken-2'
      }
      if (this.isPaciente) {
        return this.pessoa.paciente && this.pessoa.paciente.ativo ? 'green' : 'red darken-2'
      }
      return 'grey'
    },
    especialidades() {
      const fisio = this.pessoa.fisioterapeuta
      if (fisio && Array.isArray(fisio.especialidades)) {
        return fisio.especialidades.map(e => e.nome)
      }
      return []
    },
    dataNascimentoFormatada() {
      if (!this.pessoa || !this.pessoa.data_nascimento) return ''
      const [ano, mes, dia] = this.pessoa.data_nascimento.split('-')
      return `${dia}/${mes}/${ano}`
    },
  },
  methods: {
    mudarStatus() {
      const tipo = this.isFisioterapeuta ? 'fisio' : this.isPaciente ? 'paciente' : null
      if (!tipo) return

      const id = this.isFisioterapeuta
        ? this.pessoa.fisioterapeuta.id_fisio
        : this.pessoa.paciente.id_paciente

      this.$store.dispatch('mudarStatus', { tipo, id })
        .then(() => {
          if (this.isFisioterapeuta) {
            this.pessoa.fisioterapeuta.ativo = !this.pessoa.fisioterapeuta.ativo
          } else if (this.isPaciente) {
            this.pessoa.paciente.ativo = !this.pessoa.paciente.ativo
          }
          this.$emit('success', 'Status alterado com sucesso.')
        })
        .catch(() => {
          this.$emit('error', 'Erro ao alterar status')
        })
    },
    salvarEdicao() {
      const camposEditaveis = ['cpf', 'email', 'telefone'];
      const payload = { id_pessoa: this.pessoa.id_pessoa };
      camposEditaveis.forEach(campo => {
        if (this.pessoa[campo] !== undefined && this.pessoa[campo] !== null && this.pessoa[campo] !== '') {
          payload[campo] = this.pessoa[campo];
        }
      });
      this.$store.dispatch('editarPessoa', { id_pessoa: this.pessoa.id_pessoa, dados: payload })
        .then(() => {
          this.$emit('success', 'Dados editados com sucesso.')
          this.step = 1;
        })
        .catch(() => {
          this.$emit('error', 'Erro ao editar dados.')
        });
    },
  }
}
</script>